class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

open() {
  this.notification.classList.add('animate', 'active');

  this.notification.addEventListener(
    'transitionend',
    () => {
      if (window.innerWidth < 750) {
        this.notification.focus({ preventScroll: true });
      } else {
        this.notification.focus();
      }
      trapFocus(this.notification);
    },
    { once: true }
  );

  document.body.addEventListener('click', this.onBodyClick);
}

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

renderContents(parsedState) {
  this.cartItemKey = parsedState.key;
  
  // 1. Aktualizacja sekcji (wstrzyknięcie nowej cyfry do koszyka)
  this.getSectionsToRender().forEach((section) => {
    const element = document.getElementById(section.id);
    if (element) {
      element.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    }
  });

// MOBILE BEHAVIOR:
  if (window.innerWidth < 750) {
    if (this.header) {
      // Clean up Dawn's native hiding classes
      this.header.classList.remove('shopify-section-header-hidden');
      
      // Check if user is at the very top of the page
      if (window.scrollY === 0) {
        this.header.classList.add('mobile-cart-active', 'mobile-cart-top-fix');
      } else {
        this.header.classList.add('mobile-cart-active');
      }

      // Explicitly clean inline styles applied by Dawn's scroll events
      this.header.style.transform = 'none';

      // Hide header function on user interaction (scroll)
      const hideOnScroll = () => {
        this.header.classList.remove('mobile-cart-active', 'mobile-cart-top-fix');
        this.header.style.transform = ''; // Restore native styles
        window.removeEventListener('scroll', hideOnScroll);
      };

      // Clear previous scroll listeners to avoid stacking
      window.removeEventListener('scroll', window.activeCartScrollEvent);
      window.activeCartScrollEvent = hideOnScroll;

      // Allow hiding via scroll after 1 second of visibility
      setTimeout(() => {
        window.addEventListener('scroll', hideOnScroll, { passive: true });
      }, 1000);
    }
    
    // Refresh cart data securely
    try {
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-notification' });
      }
    } catch (e) {
      console.log('PubSub error:', e);
    }

    // Disable loading state on the Quick Add button
    document.querySelectorAll('.quick-add__submit').forEach(button => {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.add('hidden');
    });

  }else {
    // NA DESKTOPIE: Bez zmian
    if (this.header) this.header.reveal();
    this.open();
  }
}


  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
